export default {
    reports: [],
    form: {
        type: '',
        allTypes: [],
        locations: [],
        allLocations: [],
        requester: '',
        provider: '',
        reported: null,
        content: JSON.stringify({
            blocks: [
                {
                    key: 'd6fp7',
                    text: '',
                    type: 'unstyled',
                    depth: 0,
                    inlineStyleRanges: [],
                    entityRanges: [],
                    data: {}
                }
            ],
            entityMap: {}
        }),
        images: [],
        reportId: null
    }
};
